import axios, { AxiosResponse } from "axios";
import { ISearchParams, searchParamsInit } from "../models/searchParams";

export const searchNotifications = async (
    searchParams: ISearchParams = searchParamsInit,
    endpoint: string,
): Promise<AxiosResponse> => {
    return await axios.post(`/${endpoint}/notification/search`, searchParams);
};

export const markReadNotification = async (
    endpoint: string,
    id: string,
): Promise<AxiosResponse> => {
    return await axios.patch(`/${endpoint}/notification/read/${id}`);
};

export const markAllNotficationsAsRead = async (
    endpoint: string,
): Promise<AxiosResponse> => {
    return await axios.patch(`/${endpoint}/notification/read-all`);
};
